import type { ChecklistItemStatus, VerificationStatus } from '@/client/types/verifications';

export const STATUS_BADGE: Record<VerificationStatus, string> = {
  draft: 'bg-gray-100 text-gray-700',
  submitted: 'bg-blue-100 text-blue-700',
  in_review: 'bg-amber-100 text-amber-800',
  passed: 'bg-green-100 text-green-700',
  failed: 'bg-red-100 text-red-700',
  expired: 'bg-gray-100 text-gray-500',
  revoked: 'bg-orange-100 text-orange-800',
};

export const ITEM_STATUS_BADGE: Record<ChecklistItemStatus, string> = {
  pending: 'bg-gray-100 text-gray-600',
  submitted: 'bg-blue-100 text-blue-700',
  approved: 'bg-green-100 text-green-700',
  rejected: 'bg-red-100 text-red-700',
  not_applicable: 'bg-gray-100 text-gray-500',
};

/** Approve and reject only before a decision; revoke only after a pass.
 *  Mirrors what the API accepts, so the UI never offers a certain 400. */
export const canDecide = (s: VerificationStatus) =>
  ['draft', 'submitted', 'in_review', 'expired'].includes(s);
export const canRevoke = (s: VerificationStatus) => s === 'passed';
export const canExpire = (s: VerificationStatus) => s === 'passed';
export const canClaim = (s: VerificationStatus) => s === 'submitted';
